import React, { useEffect, useState, useCallback } from "react";
import { supabase } from "../../supabase-client";
import { hashPassword } from "../../utils/hashPassword"; // Use the utility here
import { Plus, Pencil, CircleX, ArrowLeft } from "lucide-react";

export default function Administradores() {
   const [tasks, setTasks] = useState([]);
   // const [selectedCod, setSelectedCod] = useState("");
   const [usuarios, setUsuarios] = useState([]);
   // const [imagenes, setImagenes] = useState([]);
   const [change, setChange] = useState(false);
   // var imageindx = 0;

   const fetchUsuarios = useCallback(async () => {
      const { error, data } = await supabase
         .from("admin_users")
         .select(
            `
            id,
            usuario,
            email,
            password_hash,
            recibemails
            `
         )
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading usuario: ", error.message);
         return;
      }

      setUsuarios(data);
   }, []);

   useEffect(() => {
      fetchUsuarios();
   }, [fetchUsuarios, change]);

   console.log("data: ", usuarios);

   const [editRecord, setEditRecord] = useState(null);
   const [changePassword, setChangePassword] = useState(false);
   const [newPassword, setNewPassword] = useState("");
   const [confirmPassword, setConfirmPassword] = useState("");
   
   const runChangePassword = useCallback((rec) => {
      setChangePassword(true);
      setEditRecord({ ...rec });
   }, []);

   const handleChangePassword = useCallback(async () => {
      if (newPassword !== confirmPassword) {
         alert("Las contraseñas no coinciden.");
         return;
      }
      const hashedPassword = await hashPassword(newPassword);
      // Update the user's password in the database
      const { error } = await supabase
         .from("admin_users")
         .update({ password_hash: hashedPassword })
         .eq("id", editRecord.id);

      if (error) {
         console.error("Error cambiando contraseña: ", error.message);
         alert(error.message);
         return;
      }

      alert("Contraseña cambiada con éxito.");
      setChangePassword(false);
      setNewPassword("");
      setConfirmPassword("");
   }, [newPassword, confirmPassword, editRecord?.id]);

   const handleSave = useCallback(async () => {
      console.log("editRecord: ", editRecord);
      if (!editRecord.id) {
         const hashedPassword = await hashPassword(editRecord.password_hash);
         const { data, error } = await supabase.from("admin_users").insert([
            {
               usuario: editRecord.usuario,
               email: editRecord.email,
               password_hash: hashedPassword,
               recibemails: editRecord.recibemails || "N",
            },
         ]);
         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      } else {
         const { error } = await supabase
            .from("admin_users")
            .update({
               usuario: editRecord.usuario,
               email: editRecord.email,
               recibemails: editRecord.recibemails,
            })
            .eq("id", editRecord.id);

         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      }
      setEditRecord(null);
   }, [editRecord, change]);

   const handleDelete = useCallback(async (id) => {
      const { error } = await supabase
         .from("admin_users")
         .delete()
         .eq("id", id);

      if (error) {
         console.log("error ", error);
         alert(error.message);
         return;
      }
      setChange(!change);
   }, [change]);

   const handleNewAdmin = useCallback(() => {
      setEditRecord({ recibemails: "N" });
   }, []);

   const handleCancelEdit = useCallback(() => {
      setEditRecord(null);
   }, []);

   const handleCancelPasswordChange = useCallback(() => {
      setChangePassword(false);
      setNewPassword("");
      setConfirmPassword("");
   }, []);

   console.log("tasks: ", tasks);
   // console.log("imageRecord: ", imageRecord[0].texto);
   return (
      <div className="p-6 max-w-5xl mx-auto">
         {/* Results Table */}
         <div className="mt-6">
            <div className="flex justify-between">
               <h2 className="text-lg font-semibold mb-3">Administradores</h2>
               <button
                  onClick={handleNewAdmin}
                  className="btn-green"
               >
                  <Plus className="lucid-icons-blue" /> Nuevo
               </button>
            </div>
            {usuarios.length > 0 && (
               <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-gray-200 text-gray-700">
                     <tr>
                        <th className="p-2 text-left">ID</th>
                        <th className="p-2 text-left">Usuario</th>
                        <th className="p-2 text-left">Email</th>
                        <th className="p-2 text-left">Recibe Mails</th>
                        <th className="p-2 text-left">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {usuarios.map((rec) => (
                        <tr key={rec.id} className="border-t hover:bg-gray-50">
                           <td className="p-2">{rec.id}</td>
                           <td className="p-2">{rec.usuario}</td>
                           <td className="p-2">{rec.email}</td>
                           <td className="p-2">
                              <span
                                 className={`px-2 py-1 rounded text-sm font-medium ${
                                    rec.recibemails === "S"
                                       ? "bg-green-100 text-green-800"
                                       : "bg-red-100 text-red-800"
                                 }`}
                              >
                                 {rec.recibemails === "S" ? "Sí" : "No"}
                              </span>
                           </td>
                           <td className="p-2 flex gap-2">
                              <button
                                 onClick={() => setEditRecord({ ...rec })}
                                 className="btn-green"
                              >
                                 <Pencil className="lucid-icons-blue" /> Editar
                              </button>
                              <button
                                 onClick={() => handleDelete(rec.id)}
                                 className="btn-red"
                              >
                                 <CircleX className="lucid-icons-red" /> Borrar
                              </button>
                              <button
                                 onClick={() => runChangePassword(rec)}
                                 className="btn-purple"
                              >
                                 <CircleX className="lucid-icons-red" /> Cambiar
                                 Clave
                              </button>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            )}
         </div>

         {/* Modal */}
         {editRecord && !changePassword && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-2/4">
                  <h2 className="text-xl font-bold mb-4">
                     {editRecord.id ? "Editar" : "Nuevo"} Administrador
                  </h2>

                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Usuario
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.usuario || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              usuario: e.target.value,
                           })
                        }
                     />
                  </div>

                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Email
                     </label>
                     <input
                        type="email"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.email || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              email: e.target.value,
                           })
                        }
                     />
                  </div>
                  {!editRecord.id ? (
                     <div className="flex justify-between items-center">
                        <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                           Clave de Acceso
                        </label>
                        <input
                           type="password"
                           className="w-full p-2 border rounded mb-4"
                           value={editRecord.password_hash || ""}
                           placeholder={
                              editRecord.id
                                 ? "Dejar vacío para mantener la actual"
                                 : "Ingrese la contraseña"
                           }
                           onChange={(e) =>
                              setEditRecord({
                                 ...editRecord,
                                 password_hash: e.target.value,
                              })
                           }
                        />
                     </div>
                  ) : null}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Recibe Mails
                     </label>
                     <div className="w-full mb-4">
                        <select
                           className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                           value={editRecord.recibemails || "N"}
                           onChange={(e) =>
                              setEditRecord({
                                 ...editRecord,
                                 recibemails: e.target.value,
                              })
                           }
                        >
                           <option value="N">No</option>
                           <option value="S">Sí</option>
                        </select>
                     </div>
                  </div>

                  <div className="flex justify-end gap-3">
                     <button
                        onClick={handleCancelEdit}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleSave} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Guardar
                     </button>
                  </div>
               </div>
            </div>
         )}
         {editRecord && changePassword && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-2/4">
                  <h2 className="text-lg font-semibold mb-2">
                     Cambiar Contraseña
                  </h2>
                  <div className="flex justify-between items-center">
                        <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                           Nueva Contraseña
                        </label>
                     <input
                        type="password"
                        className="w-[80%] p-2 border rounded mb-4"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                     />
                  </div>
                  <div className="flex justify-between items-center">   
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Repetir Nueva Contraseña
                     </label>
                     <input
                        type="password"
                        className="w-[80%] p-2 border rounded mb-4"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                     />
                  </div>
                  <div className="flex justify-end gap-3">
                     <button
                        onClick={handleCancelPasswordChange}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleChangePassword} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Cambiar
                     </button>
                  </div>
               </div>
            </div>
         )}
      </div>
   );
}